export const REQUEST_TAGS = 'dt/tags/REQUEST_TAGS';
export const CREATE_TAG = 'dt/tags/CREATE_TAG';
export const UPDATE_TAG = 'dt/tags/UPDATE_TAG';
export const DELETE_TAGS = 'dt/tags/DELETE_TAGS';
export const RECEIVE_TAGS = 'dt/tags/RECEIVE_TAGS';

export const requestTags = (siteId) => ({
  type: REQUEST_TAGS,
  query: { site: siteId },
});

export const createTag = (tag, callback) => ({
  type: CREATE_TAG,
  tag,
  callback,
});

export const receiveTags = (tags) => ({
  type: RECEIVE_TAGS,
  tags,
});

export const updateTag = (tag) => ({
  type: UPDATE_TAG,
  tag,
});

export const deleteTags = (siteId, tagIds, category) => ({
  type: DELETE_TAGS,
  siteId,
  tagIds,
  category,
});
